module.exports = __webpack_public_path__ + "media/images/members/trial_freelances/img_articles451_2-043dd2421e24abef59a4dd20bc16090e.png";